import makeStyles from '@mui/styles/makeStyles';

import { ErrorBoundary } from '../../components/ErrorBoundary';
import AlertsTable from './table';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    padding: `${theme.spacing(4)} 0 ${theme.spacing(3)}`,
  },
}));

interface IProps {
  stripeConnect: boolean;
}

// destructuring alias to avoid unused variable warning
export const AlertsView = ({ stripeConnect: _stripeConnect }: IProps) => {
  const classes = useStyles();

  return (
    <ErrorBoundary>
      <div className={classes.root}>
        <AlertsTable />
      </div>
    </ErrorBoundary>
  );
};
